export default __webpack_public_path__ + "static/media/rabbit34.b7549c80.gif";